<template>
  <div class="page-dialog">
    <el-descriptions size="mini" class="margin-bottom" title="" :column="3" border>
      <el-descriptions-item label="结算单号">{{ rowData.settlementNo }}</el-descriptions-item>
      <el-descriptions-item label="操作人">{{ rowData.createdByName }}</el-descriptions-item>
      <el-descriptions-item label="创建日期">{{ rowData.createdDate }}</el-descriptions-item>
    </el-descriptions>

    <div class="table-container" style="margin-bottom: 10px">
      <TableCommon
        title="明细"
        :show-header="true"
        :pagination="pagination"
        :custome-config="() => vxeShowCustom('xTable')"

        @pagination-change="handleTablePaginationChange"
      >
        <template #button>
          <table-button name="export" tip="导出" @click="exportExcel" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="450"
          align="center"
          size="medium"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          :span-method="mergeRowMethod"
        />
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { apiFindDeliverySettlementDetails } from '@/api/applyForGoods/logisticsAbnormal'
import { frontExport } from '@/utils/frontExport'

export default {
  props: {
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      conditions: {},
      pagination: {
        page: 1,
        pagesize: 100,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { title: '发货单号', field: 'wantCode', width: 100 },
          { title: '发运单号', field: 'logisticno', width: 120 },
          { title: '客户名称', field: 'customerName', width: 160 },
          { title: '产品', field: 'productDesc', width: 180 },
          // { title: '发货仓库', field: 'warehouse' },
          { title: '申请时间', field: 'createdDate', width: 135 },
          { title: '申请量', field: 'wantQuantity' , xlsxFmt: { t: 'n' }},
          { title: '发运量', field: 'actDeliveryQty', xlsxFmt: { t: 'n' }},
          { title: '应到货时间', field: 'shouldArrivedate', width: 135 },
          // { title: '到货时间', field: 'reachedTime' },
          { title: '客户签收时间', field: 'signDate', width: 135 },
          { title: '备注', field: 'remark' }
        ],
        data: []
      }
    }
  },
  created() {
    if (this.rowData.settlementNo) {
      this.queryData()
    }
  },
  methods: {
    queryData() {
      apiFindDeliverySettlementDetails({ code: this.rowData.settlementNo, ...this.pagination }).then(res => {
        const { data } = res
        this.gridOptions.data = data.Rows
        this.pagination.totalCount = data.Total
      })
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = [
        'wantCode',
        'wantQuantity',
        'customerName',
        'productDesc',
        'createdDate',
        'shouldArrivedate',
        'remark'
      ]
      const cellValue = row[column.property]
      if (column.property === 'wantCode') {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      } else if (fields.includes(column.property)) {
        let nextRow = visibleData[_rowIndex + 1]
        const prevRow = visibleData[_rowIndex - 1]
        if (prevRow && prevRow['wantCode'] === row['wantCode']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['wantCode'] === row['wantCode']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return {
              rowspan: countRowspan,
              colspan: 1
            }
          }
        }
      }
    },
    async exportExcel() {
      const { data } = await apiFindDeliverySettlementDetails({ code: this.rowData.settlementNo, page: 1, pagesize: this.pagination.totalCount })
      frontExport(this.gridOptions.columns, data.Rows, '发货运费结算明细')
    },
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      this.queryData()
    }
  }
}
</script>

<style>
.margin-bottom{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/components/DeliveryFeeCheck1.vue